// const urldata = "http://13.233.110.14:4000/api/";
const urldata = `${process.env.REACT_APP_API_URL}/api/`;
export default urldata;
